<template>
  <div class="w-full h-full">
    <div class="relative flex flex-col h-full">
      <two-blocks-layout :navigate="navigate" v-bind="page" class="my-auto" col>
        <span class="text-title-md" v-text="page.titolo" />
        <template #right>
          <div
            class="sm:grid-cols-2 md:grid-cols-3 grid grid-flow-row grid-cols-1 gap-4"
          >
            <img
              v-for="img in page.partners"
              :key="img.logo"
              :src="img.logo"
              class="max-h-40 mx-auto my-auto"
            />
          </div>
        </template>
      </two-blocks-layout>
      <app-cta-button
        cta
        mobile-only
        full-width
        :link="apriContoUrl"
        external
      />
    </div>
  </div>
</template>

<script>
import { axios } from "@/plugins/axios";
import TwoBlocksLayout from "@/components/page-layouts/TwoBlocksLayout.vue";

export default {
  components: { TwoBlocksLayout },
  props: { navigate: { default: null } },
  async beforeRouteEnter(to, from, next) {
    let page;
    try {
      page = await axios.get(`/pageContent${to.path}.json`);
    } catch (error) {
      page = {};
    } finally {
      next(vm => (vm.page = page.data));
    }
  }
};
</script>
<route>
{
  "name": "partner",
  "meta": {
      "order": 12,
      "label": "I nostri Partner",
      "hideMenu": {
        "inline": true,
        "main": true
      }  }
}
</route>
